import _keyBy from 'lodash/keyBy';

import ImageHotspotViewField from '@/modules/corporate/modules/questions/fields/image-hotspot/Field/View';
import MatchTheFollowingViewField from '@/modules/corporate/modules/questions/fields/match-the-following/Field/View';
import MultiSelectViewField from '@/modules/corporate/modules/questions/fields/multi-select/Field/View';
import PictureChoiceViewField from '@/modules/corporate/modules/questions/fields/picture-choice/Field/View';
import SingleSelectViewField from '@/modules/corporate/modules/questions/fields/single-select/Field/View';
import TrueFalseViewField from '@/modules/corporate/modules/questions/fields/true-or-false/Field/View';

import FillInTheBlanksViewField from './fill-in-the-blanks/Field/View';

export const ALL_VIEW_FIELDS = [
  SingleSelectViewField,
  MultiSelectViewField,
  TrueFalseViewField,
  PictureChoiceViewField,
  MatchTheFollowingViewField,
  FillInTheBlanksViewField,
  ImageHotspotViewField,
];

export const ViewFields = _keyBy(ALL_VIEW_FIELDS, 'type');
